module.exports = __webpack_public_path__ + "img/chat-dots-fill-svgrepo-com.9b226ade.svg";